import axios from "axios";
import { USER_DATA,SET_SEARCH,SECOND_STEP_DETAILS,SET_CATEGORY,SET_PROFILE_DATA,INTRO_DETAILS,SUBMISSION_DATA } from "./types";
import { APIURL } from "./config";
import { Loading, Notify } from "notiflix";
import { getQueryString, getSearchQueryString } from "../../helper";
export const updateBasicDetails = (data, notify = true) => async dispatch => {

   const config = {
      headers: {
         'ContentType': 'application/json',
      }
   }
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/student/profile/update/basicdetails`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ?? "Basic details are updated successfully."
         if (notify) Notify.success(message);
        //  dispatch({
        //     type: USER_DATA,
        //     payload: res?.data?.body
        //  });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}
export const updateIntroVideo = (data, notify = true) => async dispatch => {

   const config = {
      headers: {
         'ContentType': 'application/json',
      }
   }
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/student/profile/update/introvideo`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ?? "Intro video updated successfully."
         if (notify) Notify.success(message);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}
export const togglePublic = (params, notify = true) => async dispatch => {
const queryString = getQueryString(params)
   const config = {
      headers: {
         'ContentType': 'application/json',
      }
   }
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/competition/portfolio/togglePublic?${queryString}`, {}, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ?? "video state changed successfully."
         if (notify) Notify.success(message);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}
export const updateJobPreference = (data, notify = true) => async dispatch => {

   const config = {
      headers: {
         'ContentType': 'application/json',
      }
   }
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/student/profile/update/jobpreference`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ?? "Job Preferences updated successfully."
         if (notify) Notify.success(message);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}
export const updateEducation = (data, notify = true) => async dispatch => {

   const config = {
      headers: {
         'ContentType': 'application/json',
      }
   }
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/student/profile/update/education`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ?? "Education details updated successfully."
         if (notify) Notify.success(message);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}
export const updateProfileSummary = (data, notify = true) => async dispatch => {

   const config = {
      headers: {
         'ContentType': 'application/json',
      }
   }
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/student/profile/update/profilesummary`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ?? "Profile summary details updated successfully."
         if (notify) Notify.success(message);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}
export const updateProfessionalExperience = (data, notify = true) => async dispatch => {

   const config = {
      headers: {
         'ContentType': 'application/json',
      }
   }
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/student/profile/update/profexp`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ?? "Professional experience details updated successfully."
         if (notify) Notify.success(message);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}
export const updateAdditionalInfo = (data, notify = true) => async dispatch => {

   const config = {
      headers: {
         'ContentType': 'application/json',
      }
   }
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/student/profile/update/addtninfo`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ?? "Additional Info details updated successfully."
         if (notify) Notify.success(message);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}

export const uploadWithoutPresigned = (data, notify = true) => async dispatch => {

   const config = {
      headers: {
         'ContentType': 'application/json',
      }
   }
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/student/profile/update/basicskills`, data , config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({
            type: SUBMISSION_DATA,
            payload: res?.data?.body
         });
         const message = res?.data?.message ?? ""
         if (notify) Notify.success(message);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}

export const deleteSubmission = (params, notify = true) => async dispatch => {

   const config = {
      headers: {
         'ContentType': 'application/json',
      }
   }
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/competition/portfolio/deleteSubmission?submissionId=${params}`, {}, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ?? "Deleted successfully."
         if (notify) Notify.success(message);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}

export const fetchNormalSubmission = (params) => async dispatch => {
const queryString = getQueryString(params)
   const config = {
      headers: {
         'ContentType': 'application/json',
      },
      data: {}
   }
   try {
      const res = await axios.get(`${APIURL}/api/student/profile/fetch/resumedetails?${queryString}`, config);
      if (res?.data?.status) {
         dispatch({
            type: SUBMISSION_DATA,
            payload: res?.data?.data?.data
         });
         // if (cb) cb(res?.data?.body?.user);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}

export const fetchBasicSkillsSubmission = (params) => async dispatch => {
const queryString = getQueryString(params)
   const config = {
      headers: {
         'ContentType': 'application/json',
      },
      data: {}
   }
   try {
      const res = await axios.get(`${APIURL}/api/student/profile/fetch/basicskills?${queryString}`, config);
      if (res?.data?.status) {
         dispatch({
            type: SUBMISSION_DATA,
            payload: res?.data?.data?.data
         });
         // if (cb) cb(res?.data?.body?.user);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}

export const getUser = (cb) => async dispatch => {

   const config = {
      headers: {
         'ContentType': 'application/json',
      },
      data: {}
   }
   try {
      const res = await axios.get(`${APIURL}/api/entity/user`, config);
      if (res?.data?.status) {
         dispatch({
            type: USER_DATA,
            payload: res?.data?.body
         });
         if (cb) cb(res?.data?.body?.user);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}
export const getProfile = (id) => async dispatch => {

   const config = {
      headers: {
         'ContentType': 'application/json',
      },
      data: {}
   }
   try {
      const res = await axios.get(`${APIURL}/api/student/fetch/profile/${id}`, config);
      if (res?.data?.status) {
         dispatch({
            type: SET_PROFILE_DATA,
            payload: res?.data?.data
         });
         // if (cb) cb(res?.data?.body?.user);
      } else if (res?.data?.message) {
         // Notify.warning(res?.data?.message);
      } else {
         // Notify.warning("something went wrong");
      }

   } catch (err) {
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}
export const secondStepDetails = (params) => async dispatch => {
const queryString = getQueryString(params)
   const config = {
      headers: {
         'ContentType': 'application/json',
      },
      data: {}
   }
   try {
      const res = await axios.get(`${APIURL}/api/competition/activities/mnbasic?${queryString}`, config);
      if (res?.data?.status) {
         dispatch({
            type: SECOND_STEP_DETAILS,
            payload: res?.data?.data
         });
         // if (cb) cb(res?.data?.body?.user);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}
export const introVideoDetails = (params) => async dispatch => {
const queryString = getQueryString(params)
   const config = {
      headers: {
         'ContentType': 'application/json',
      },
      data: {}
   }
   try {
      const res = await axios.get(`${APIURL}/api/student/profile/fetch/introvideo?${queryString}`, config);
      if (res?.data?.status) {
         dispatch({
            type: INTRO_DETAILS,
            payload: res.data.data.data.submission
         });
         // if (cb) cb(res?.data?.body?.user);
      } else if (res?.data?.message) {
         // Notify.warning(res?.data?.message);
      } else {
         // Notify.warning("something went wrong");
      }

   } catch (err) {
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}

export const fetchSearch = (params,context) => async dispatch => {
const queryString = getSearchQueryString(params)
   const config = {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    data: {},
  };
   try {
      Loading.standard();
      const res = await axios.get(`${APIURL}/api/student/filter/charsearch?${queryString}`, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ?? "Account is deleted successfully."
        //  Notify.success(message);
        //  dispatch(logoutApp());
        dispatch({
            type: SET_SEARCH,
            payload: res?.data?.data,
            context: params.context
         });
         
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}

export const fetchCategory = (params) => async dispatch => {
const queryString = getQueryString(params)
   const config = {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    data: {},
  };
   try {
      Loading.standard();
      const res = await axios.get(`${APIURL}/api/company/job/screening/list/activities?${queryString}`, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ?? "Account is deleted successfully."
        //  Notify.success(message);
        //  dispatch(logoutApp());
        dispatch({
            type: SET_CATEGORY,
            payload: res?.data?.data,
         });
         
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? "internal server error";
      Notify.failure(message);
   }
}